// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3fz4T","approved":"Status_approved__3F5CY","rejected":"Status_rejected__2gyXH","expired":"Status_expired__15LDa","label":"Status_label__181lu"};